export const EMBED_CONFIG = {
	mida_home: '978px',
	mida_noticia_lg: '1160px', //Mida fixa de 1160px
	mida_noticia_md: '600px', //de 600px a 720px
	mida_noticia_sm: '320px', //de 320px a 600px
	mida_noticia_xsm: '280px', //de 280px a 320px
} as const
